module.exports = __webpack_public_path__ + "img/5.b2751def.jpg";